import { ApiReceivingLogRow } from './ApiReceivingLogRow';

export class GetReceivingLogsResponse {
    public constructor(init?: Partial<GetReceivingLogsResponse>) {
        Object.assign(this, init);
    }

    totalRowCount: number = 0;
    logList: ApiReceivingLogRow[] = [];
}